import { Component, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery'
import 'datatables.net';
import 'datatables.net-bs4';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DvrdetailsdialogComponent } from '../dvrdetailsdialog/dvrdetailsdialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

import { NgDialogAnimationService } from 'ng-dialog-animation';
import { DataServiceService } from '../data-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ErrorService } from '../error.service';



interface dvrlistdetails {
  buildingName: string;
  ipAddress: string;
  rtspPortNo: number;
  httpPortNo: string;
  userName: string;
  password: number;
  dvrModelNumber: number;
  // serialNumber: number;
  maxNoOfChannels: string;
  totalCamerasInstalled: string;
  totalWorkingCameras: string;
  rtspAuthentication: string;
}

@Component({
  selector: 'app-add-dvr',
  templateUrl: './add-dvr.component.html',
  styleUrls: ['./add-dvr.component.scss']
})

export class AddDvrComponent implements OnInit {

  displayedColumns: string[] = [
    'buildingName', 'ipAddress', 'rtspPortNo', 'httpPortNo', 'userName', 'password',
    'dvrModelNumber', 'maxNoOfChannels', 'totalCamerasInstalled', 'totalWorkingCameras', 'rtspAuthentication', 'view'
  ];

  dataSource = new MatTableDataSource<dvrlistdetails>([]);
  dataAvailable = true;

  // @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  //store campus id here //
  buildingId: any;
  //store end here
  dvrlistdetails: any;
  campusname1: any;
  cityid: any;
  cityname: any;
  statename: any;
  stateid: any;
  campusid: any;
  oracledata: any;
  searchorg: string = '';
  myForm!: FormGroup;
  imageFormat: any;
  dvrStatus: any;
  cctvDetId: any;
  buildingname: any;
  buildingaddress: any;
  orcFusionBuildingCode:any;
  segmentType:any;

  constructor(private fb: FormBuilder, private _snackBar: MatSnackBar, public dialog: NgDialogAnimationService, private dataService: DataServiceService, private spinner: NgxSpinnerService, private errorService: ErrorService,) {

  }
  ngOnInit(): void {
    this.dvrdetails();

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }
  // dvrlistdetails = [{
  //   name: '2 Nd Campus -nara1', ipaddress: '175.101.62.210554', rtsp: '554', http: '8000', user: 'vijay', password: 'Vijay@123', Model: 'DS-7108HGHI-K1', SerialNo: 'DS-7108HGHI-K10820220311CCWRJ63887344WCVU', maxchannel: '14', totalinstalled: '15', totalworking: '8', authentication: 'ok'
  //   , view: 'view'
  // }]

  dvrdetails() {
    $('#example').DataTable().destroy();
    $(document).ready(() => {
      $('#example').DataTable({
        scrollX: true,
      });

    });
  }

  dvrdetailslist(buildingId: any) {
    this.spinner.show();
    this.dataService.dvrcampusdetails(buildingId).subscribe(
      {
        next: (data: any) => {
          if (data && data.dvrOrNvrList.length > 0) {
            this.dataSource.data = data.dvrOrNvrList; // Set the dataSource with the correct data
            // this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.dataAvailable = true; // Data is available
          } else {
            this.dataSource.data = []; // Clear the dataSource
            this.dataAvailable = false; // No data available
            console.warn('Unexpected API response structure:', data);
          }
          this.spinner.hide();
        }, error: (error: any) => {
          this.spinner.hide();
          this.errorService.errorDisplay(Number(error.status), "Error", "");
          this.dataAvailable = false; // Handle error case
        }
        // this.dvrlistdetails = res.dvrOrNvrList;
        // this.imageFormat = this.data.dvrOrNvrList[0].imageFormat;
        // this.dvrStatus = this.dvrlistdetails[0].dvrStatus;
        // this.cctvDetId = this.dvrlistdetails[0].cctvDetId;
        // this.dvrdetails();
        // this.spinner.hide();
        // console.log('dvrlist', this.dvrlistdetails);
      });
  }

  opendvr() {
    const dialogRef = this.dialog.open(DvrdetailsdialogComponent, {
      direction: 'ltr',
      height: '100%',
      width: '40%',
      position: { right: '0px', top: '0px' },
      animation: { to: "left" },
      data: {
        campusName: this.campusname1,
        campusId: this.campusid,
        buildingAddress: this.buildingaddress,
        buildingName1: this.buildingname,
        buildingId: this.buildingId,
        cityId: this.cityid,
        cityName: this.cityname,
        stateId: this.stateid,
        stateName: this.statename,
        segmentType:this.segmentType,
        orcFusionBuildingCode:this.orcFusionBuildingCode
      }
      // disableClose:true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'save') {
        // $('#example').DataTable().destroy();
        this.dvrdetailslist(this.buildingId);
        // this.dvrlistdetails.splice(i,1,result);
        console.log('result', result);
      }
      // if (result != null) {
      //   this.dvrlistdetails.push(result)
      //   console.log('result', result);
      // }
    });

  }

  opendvrdetails(dvr: any) {
    dvr.campusName = this.campusname1
    dvr.cityId = this.cityid
    dvr.cityName = this.cityname
    dvr.stateId = this.stateid
    dvr.stateName = this.statename
    dvr.orcFusionBuildingCode=this.orcFusionBuildingCode
    dvr.segmentType=this.segmentType

    let dialogRef = this.dialog.open(DvrdetailsdialogComponent, {
      data: dvr,
      direction: 'ltr',
      height: '100%',
      width: '40%',
      position: { right: '0px', top: '0px' },
      animation: { to: "left" },
    });
    dialogRef.afterClosed()
      .subscribe(result => {
        if (result == 'save') {
          // $('#example').DataTable().destroy();
          this.dvrdetailslist(this.buildingId);
          // this.dvrlistdetails.splice(i,1,result);
          console.log('result', result);
        }
      });
  }

  onKeydown(event:any) {
    if (event.key === "Enter") {
      this.search(this.searchorg)
      console.log(event);
    }
  }
  



  search(searchorg: any) {
    this.spinner.show();
    this.dataService.orafusion(searchorg).subscribe(
      {
        next: (res) => {
          this.oracledata = res;
          console.log('orc', this.oracledata);
          this.campusname1 = this.oracledata[0].campusName;
          this.cityid = this.oracledata[0].cityId;
          this.cityname = this.oracledata[0].cityName;
          this.stateid = this.oracledata[0].stateId;
          this.statename = this.oracledata[0].stateName;
          this.campusid = this.oracledata[0].campusId;
          this.buildingname = this.oracledata[0].buildingName;
          this.buildingaddress = this.oracledata[0].buildingAddress;
          this.orcFusionBuildingCode=this.oracledata[0].orcFusionBuildingCode;
          this.segmentType=this.oracledata[0].segmentType;
          console.log('cam', this.campusname1);
          this.spinner.hide();
          this.buildingId = this.oracledata[0].buildingId;
          this.dvrdetailslist(this.buildingId)
          console.log(this.buildingId);
        }, error: (error: any) => {
          this.spinner.hide();
          this.oracledata =[];
          this.errorService.errorDisplay(Number(error.status), "Error", error.error.message);
        }
      }
    );

  }


}
